const GUID_PATTERN =
  /^[{]?[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}[}]?$/i;

export const extractGuids = (...values) => {
  const guids = new Set();

  const visit = (value, depth = 0) => {
    if (value === null || value === undefined || depth > 5) return;

    if (Array.isArray(value)) {
      value.forEach((item) => visit(item, depth + 1));
      return;
    }

    if (typeof value === "object") {
      [
        value.idImagen,
        value.idResource,
        value.id,
        value.imagen,
        value.imagenes,
        value.images,
      ].forEach((item) => visit(item, depth + 1));
      return;
    }

    if (typeof value !== "string") return;
    const candidate = value.trim();
    if (!candidate) return;

    if (GUID_PATTERN.test(candidate)) {
      guids.add(candidate.replace(/[{}]/g, ""));
      return;
    }

    if (candidate.startsWith("[") || candidate.startsWith("{")) {
      try {
        visit(JSON.parse(candidate), depth + 1);
      } catch {
        // No es JSON válido ni GUID; se descarta.
      }
    }
  };

  values.forEach((value) => visit(value));
  return Array.from(guids);
};
